import React from 'react';
import CosmicIcon from '../../common/CosmicIcon';
import './CosmicResultsNavigation.css';

/**
 * Cosmic Results Navigation - Mobile-first tab system
 * Fixed position navigation with cosmic styling
 */
const CosmicResultsNavigation = ({ activeTab, onTabChange, shareControl = null, hideCareers = false }) => {
  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'results_overview' },
    { id: 'domains', label: 'Domains', icon: 'results_domains' },
    // An APC client's careers work happens in their portal (2026-10-30).
    ...(hideCareers ? [] : [{ id: 'careers', label: 'Careers', icon: 'results_careers' }])
  ];

  return (
    <nav className="cosmic-results-navigation">
      <div className="cosmic-nav-container cosmic-nav-container--with-share">
        {/* The APC logo, upper left (Dan, 2026-10-30). */}
        <div className="cosmic-nav-logo-slot">
          <img src="/apc-logo-light.png" alt="A Portland Career" className="cosmic-nav-logo" />
        </div>
        <div className="cosmic-nav-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`cosmic-nav-tab ${activeTab === tab.id ? 'cosmic-nav-tab--active' : ''}`}
              onClick={() => onTabChange(tab.id)}
              aria-selected={activeTab === tab.id}
              role="tab"
            >
              <span className="cosmic-nav-icon"><CosmicIcon name={tab.icon} size={26} decorative /></span>
              <span className="cosmic-nav-label">{tab.label}</span>
            </button>
          ))}
        </div>
        {shareControl && (
          <div className="cosmic-nav-share-slot">{shareControl}</div>
        )}
      </div>
    </nav>
  );
};

export default CosmicResultsNavigation;
